$(document).ready(function () {
  var domainShop = "4606ff-87.myshopify.com";
  var HIDE_THRESHOLD = 20000;

  var subtotalObserver = null;
  var cartObserver = null;
  var updateTimer = null;
  var lastSubtotal = null;

  function formatAmount(value) {
    return new Intl.NumberFormat("en-PK", {
      maximumFractionDigits: 0
    }).format(Math.round(value || 0));
  }

  function parseMoney(text) {
    if (!text) return 0;

    var str = String(text).replace(/\u00a0/g, " ").trim();

    // Works for:
    // Rs.48,986.00 PKR
    // Rs. 15,000.00
    // PKR 15000
    // 15,000
    var matches = str.match(/(\d{1,3}(?:,\d{3})+(?:\.\d+)?|\d+(?:\.\d+)?)/g);

    if (!matches || !matches.length) return 0;

    var raw = matches[matches.length - 1].replace(/,/g, "");
    var num = parseFloat(raw);

    return isNaN(num) ? 0 : Math.round(num);
  }

  function getPercentageFromStore() {
    var p = parseFloat(sessionStorage.getItem("percentageAmount"));
    return isNaN(p) ? 0 : p;
  }

  function setPercentageToStore(result) {
    if (!Array.isArray(result) || !result.length) return;

    var fee = result[0] && result[0].fee ? result[0].fee : 0;
    var pct = parseInt(fee, 10);

    if (!isNaN(pct)) {
      sessionStorage.setItem("percentageAmount", String(pct / 100));
    }
  }

  function updateShopLimits(result) {
    var maxL = result && result[0] ? result[0].max_shop_limit : "";
    var minL = result && result[0] ? result[0].min_shop_limit : "";

    $("#upperlimit, .upperlimit").text(formatAmount(parseMoney(maxL)));
    $("#lowerlimit, .lowerlimit").text(formatAmount(parseMoney(minL)));
  }

  function getSubtotalElement() {
    return (
      document.querySelector(".cart-totals__total-value") ||
      document.querySelector('[data-testid="cart-total-value"]') ||
      document.querySelector("[data-cart-subtotal]") ||
      document.querySelector(".t4s-cart__totalPrice") ||
      document.querySelector(".totals__subtotal .money") ||
      document.querySelector(".cart__footer .totals__subtotal-value") ||
      document.querySelector(".cart-drawer .totals__subtotal-value") ||
      document.querySelector(".cart-subtotal .money") ||
      document.querySelector("[data-cart-total]") ||
      document.querySelector("[data-subtotal]")
    );
  }

  function getCartTotal() {
    var subtotalEl = getSubtotalElement();

    if (!subtotalEl) return 0;

    var subtotalText = subtotalEl.textContent || subtotalEl.innerText || "";
    return parseMoney(subtotalText);
  }

  function hideShowWidget(cartTotal) {
    var $widget = $(".drawer-total-label");

    if (!$widget.length) return;

    if (cartTotal >= HIDE_THRESHOLD) {
      $widget
        .addClass("drawer-hidden")
        .attr("hidden", true)
        .css("display", "none");
    } else {
      $widget
        .removeClass("drawer-hidden")
        .removeAttr("hidden")
        .css("display", "");
    }
  }

  function updateInstallment(cartTotal) {
    var percentage = getPercentageFromStore();

    var feeAmount = cartTotal * percentage;
    var installment = Math.floor((cartTotal + feeAmount) / 3);

    var $installmentEl = $(".price-divide-cart");

    if ($installmentEl.length) {
      $installmentEl.text(formatAmount(installment));
    }

    hideShowWidget(cartTotal);
  }

  function updateBaadmayPrice1(forceUpdate) {
    var cartTotal = getCartTotal();

    if (!cartTotal) return;

    if (!forceUpdate && cartTotal === lastSubtotal) return;

    lastSubtotal = cartTotal;

    updateInstallment(cartTotal);
  }

  function scheduleUpdate(forceUpdate) {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      updateBaadmayPrice1(forceUpdate);
    }, 120);
  }

  function observeSubtotalNode() {
    if (subtotalObserver) {
      try {
        subtotalObserver.disconnect();
      } catch (e) {}

      subtotalObserver = null;
    }

    var subtotalEl = getSubtotalElement();

    if (!subtotalEl) return;

    subtotalObserver = new MutationObserver(function () {
      scheduleUpdate(true);
    });

    subtotalObserver.observe(subtotalEl, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["value", "data-cart-subtotal", "data-cart-total", "class"]
    });
  }

  function observeCartContainer() {
    if (cartObserver) {
      try {
        cartObserver.disconnect();
      } catch (e) {}

      cartObserver = null;
    }

    var container =
      document.querySelector("#CartDrawer") ||
      document.querySelector("cart-drawer") ||
      document.querySelector(".cart-drawer") ||
      document.querySelector(".cart") ||
      document.querySelector("cart-items") ||
      document.querySelector("cart-form") ||
      document.body;

    cartObserver = new MutationObserver(function (mutations) {
      var shouldRefresh = false;

      mutations.forEach(function (mutation) {
        if (shouldRefresh) return;

        if (
          mutation.target &&
          $(mutation.target).closest(".baadmay-gateway-wrapper").length
        ) {
          return;
        }

        if (mutation.type === "childList") {
          if (mutation.addedNodes.length || mutation.removedNodes.length) {
            shouldRefresh = true;
          }
        }

        if (mutation.type === "characterData" || mutation.type === "attributes") {
          shouldRefresh = true;
        }
      });

      if (shouldRefresh) {
        observeSubtotalNode();
        scheduleUpdate(true);
      }
    });

    cartObserver.observe(container, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true
    });
  }

  function fetchBaadmayData() {
    var storedData = sessionStorage.getItem("baadmayData");

    if (storedData) {
      try {
        return Promise.resolve(JSON.parse(storedData));
      } catch (e) {
        sessionStorage.removeItem("baadmayData");
      }
    }

    return $.get(
      "https://cms.baadmay.com/Fees?merchant_name=" + domainShop
    ).then(function (data) {
      sessionStorage.setItem("baadmayData", JSON.stringify(data));
      return data;
    });
  }

  function refreshCartPrice() {
    observeSubtotalNode();
    scheduleUpdate(true);
  }

  $(document).on(
    "input change click keyup",
    [
      ".cart-totals__total-value",
      '[data-testid="cart-total-value"]',
      "[data-cart-subtotal]",
      "[data-cart-total]",
      ".t4s-cart__totalPrice",
      ".totals__subtotal .money",
      ".cart__footer .totals__subtotal-value",
      ".cart-drawer .totals__subtotal-value",
      ".cart-subtotal .money",
      ".quantity__input",
      ".cart-item__quantity input",
      ".cart-remove-button",
      "[name='updates[]']",
      "cart-remove-button",
      "quantity-input button",
      ".quantity button"
    ].join(","),
    function () {
      refreshCartPrice();
    }
  );

  $(document).on(
    "cart:refresh cart:updated cart:update cart:change cart:build cart:rendered drawer:open",
    function () {
      refreshCartPrice();
    }
  );

  $(document).ajaxComplete(function () {
    refreshCartPrice();
  });

  document.addEventListener("shopify:section:load", function () {
    refreshCartPrice();
  });

  document.addEventListener("DOMContentLoaded", function () {
    refreshCartPrice();
  });

  fetchBaadmayData()
    .then(function (data) {
      setPercentageToStore(data);
      updateShopLimits(data);
      observeSubtotalNode();
      observeCartContainer();
      updateBaadmayPrice1(true);
    })
    .catch(function () {
      observeSubtotalNode();
      observeCartContainer();
      updateBaadmayPrice1(true);
    });
});